import request from '@/utils/request'
import logger from '@/utils/logger'

import API from './base'

class LeanAPI extends API {
  fetchLeanSession(leanSessionId) {
    logger.trace('Fetching lean session details', leanSessionId)
    return request({
      method: 'GET',
      trackingKey: 'fds_customer_leantech-connect_LEAN-SESSION-ID',
      path: `/fds/customer/leantech-connect/${leanSessionId}`,
    })
  }

  logUserAction(leanSessionId, data) {
    logger.trace('Submit lean session response', leanSessionId, data)

    return request({
      method: 'POST',
      trackingKey: 'risk-logging_leantech-connect_LEAN-SESSION-ID_log',
      path: `/risk-logging/leantech-connect/${leanSessionId}/log`,
      data,
    })
  }

  fetchLinkStatus(leanSessionId) {
    logger.trace('Fetching link status', leanSessionId)
    return request({
      method: 'GET',
      trackingKey: 'fds_customer_leantech-connect_LEAN-SESSION-ID_status',
      path: `/fds/customer/leantech-connect/${leanSessionId}/status`,
    })
  }
}
export default new LeanAPI('/lean')
